import { reactive, ref, computed } from '@vue/composition-api';

const clipboard = ref({
  text: null,
  type: 'block',
  blockData: {
    blockIds: [],
    parent: null,
    contents: []
  },
  clipData: {
    resourceId: null,
    clipId: null
  }
});

export default function useClipboard() {
  const setClipboard = value => {
    clipboard.value = value;
    console.log(clipboard);
  };

  const resetClipboard = () => {
    clipboard.value = {
      text: null,
      type: 'block',
      blockData: {
        blockIds: [],
        parent: null,
        contents: []
      },
      clipData: {
        resourceId: null,
        clipId: null
      }
    };
  };

  return {
    setClipboard,
    resetClipboard,
    clipboard
  };
}
